// removed by extract-text-webpack-plugin
module.exports = {"social-links":"_24smvjDO","socialLinks":"_24smvjDO","link":"EcAkzp9j"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SocialLinks/SocialLinks.pcss
// module id = 407
// module chunks = 0